import { connect } from 'react-redux'

import PaySalary from '../../components/salary/paySalary.component'

import {
  getNewSalaryStart,
  selectRowSalary,
  postSalary,
  cancelPaySalary,
  warnToAddCost,
  warnNoSSN,
  getReferralDiscountByEmail,
  closeDialogSalary,
  sendReferralCode,
  closeSalarySnackbar,
  handleRefreshClick
} from '../../actions/index'

const mapStateToProps = (state) => {
  const selectedIds =
    state.salary.selectedRows.length > 0
      ? state.salary.selectedRows.map((el) => state.salary.newSalary[el])
      : []
  const { adminUser } = state
  return {
    newSalary: state.salary.newSalary,
    taxPercent: state.salary.taxPercent,
    newSalarySummary: state.salary.newSalarySummary,
    selectedRows: state.salary.selectedRows,
    salaries: selectedIds,
    isSalaryInfo: state.salary.isSalaryInfo,
    newSalaryInfo: state.salary.newSalaryInfo,
    showDialog: state.salary.showDialog,
    willGetDiscount: state.salary.willGetDiscount,
    recommendedPersonGetDiscount: state.salary.recommendedPersonGetDiscount,
    referrerPersonGetDiscount: state.salary.referrerPersonGetDiscount,
    discount: state.salary.discount,
    allSalaries: state.salary.allSalaries,
    sendCodeSuccess: state.salary.sendCodeSuccess,
    sendCodeFailed: state.salary.sendCodeFailed,
    nerverUseDiscount: state.salary.nerverUseDiscount,
    isCodeActivated: state.salary.isCodeActivated,
    selectedUser: adminUser.selectedUser
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getNewSalaryStart: (data) => dispatch(getNewSalaryStart(data)),
    selectRowSalary: (selected) => dispatch(selectRowSalary(selected)),
    postSalary: (selected) => dispatch(postSalary(selected)),
    cancelPaySalary: () => dispatch(cancelPaySalary()),
    warnToAddCost: () => dispatch(warnToAddCost()),
    warnNoSSN: () => dispatch(warnNoSSN()),
    getReferralDiscountByEmail: (data) =>
      dispatch(getReferralDiscountByEmail(data)),
    closeDialogSalary: () => dispatch(closeDialogSalary()),
    sendReferralCode: (data) => dispatch(sendReferralCode(data)),
    closeSalarySnackbar: () => dispatch(closeSalarySnackbar()),
    handleRefreshClick: () => dispatch(handleRefreshClick())
  }
}

const PaySalaryContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaySalary)

export default PaySalaryContainer
